module.exports = __webpack_public_path__ + "static/media/Ex.0fa0448d.svg";